<template>
  <div id="demo-basic-card">

    <vs-alert color="danger" title="User Not Found" :active.sync="package_not_found">
        <span>Package record with id: {{ $route.params.packageId }} not found. </span>
        <span>
            <span>Check </span><router-link :to="{name:'packages'}" class="text-inherit underline">All Packages</router-link>
        </span>
    </vs-alert>

    <div id="module-data" v-if="package_data">
        <vx-card :title="package_data.name" class="mb-base">
            <template   slot="actions">
                <vx-tooltip :text="'Edit '+package_data.name" position="left">
                    <feather-icon @click="redirectToEditPackage()" icon="EditIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>

            <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="carousel-example" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                        <swiper :options="swiperOption">
                            <swiper-slide>
                                <img class="responsive" :src="package_data.image" alt="banner">
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-list>
                        <vs-list-item title="Name" :subtitle="package_data.name"></vs-list-item>
                        <vs-list-item title="Modules" :subtitle="''+package_data.modules.length"></vs-list-item>
                        <vs-list-item title="Price Type" :subtitle="package_data.price_type"></vs-list-item>
                        <vs-list-item title="Price" :subtitle="''+package_data.cost"></vs-list-item>
                        <vs-list-item title="Status" :subtitle="package_data.status"></vs-list-item>
                        <vs-list-item title="Description" :subtitle="package_data.description"></vs-list-item>
                    </vs-list>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col  w-full mb-2">
                    <span class="mb-2">Modules</span>
                    <swiper :options="swiperOption_" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                        <swiper-slide v-for="(listItem, index) in package_data.modules" :key="index">
                            <div @click="redirectToViewModule(listItem)" style="cursor: pointer;">
                                <span>{{ listItem.name }} ({{ getLessionNumber(listItem) }})</span>
                                <img class="responsive" :src="listItem.image" alt="banner">
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
            </div>
        </vx-card>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default{
    data() {
        return {
            package_data: null,
            package_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            swiperOption_: {
                slidesPerView: 4,
                spaceBetween: 50,
                // init: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    }
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
    },
    methods: {
        redirectToViewModule(moduleData) {
            this.$router.push("/modules/view/" + moduleData.id).catch(() => {})
        },
        getLessionNumber(moduleData) {
            if(moduleData.lession_number && moduleData.lession_number.length){
                return moduleData.lession_number.join(', ');
            }
            else return ""
        },
        redirectToEditPackage() {
            this.$router.push("/packages/edit/" + this.package_data.id).catch(() => {})
        },
    },
    created() {
        if(!modulePackageManagement.isRegistered) {
            this.$store.registerModule('packageManagement', modulePackageManagement)
            modulePackageManagement.isRegistered = true
        }

        const packageId = this.$route.params.packageId
        this.$store.dispatch("packageManagement/getAPackage", packageId)
            .then(res => { this.package_data = res.data })
            .catch(err => {
                if(err.response.status === 404) {
                    this.package_not_found = true
                    return
                } 
            })
    },
}
</script>

